import { useTranslation } from "react-i18next";
import { ShieldCheck, Check } from "lucide-react";

/**
 * "Independent healthcare coordination and patient-support service" strip.
 * variant: "panel" (bordered card) | "band" (full mint band)
 */
export const IndependenceStrip = ({ variant = "panel", className = "" }) => {
  const { t } = useTranslation();
  const isBand = variant === "band";
  const points = t("independence.points", { returnObjects: true }) || [];
  return (
    <div
      data-testid="independence-strip"
      className={`${isBand ? "bg-mint" : "border border-[hsl(var(--vc-line))] bg-white vc-shadow-soft"} rounded-2xl p-6 sm:p-7 ${className}`}
    >
      <div className="flex items-start gap-3">
        <span className="grid h-9 w-9 shrink-0 place-items-center rounded-lg bg-brand text-white">
          <ShieldCheck className="h-5 w-5" />
        </span>
        <p className="text-base font-semibold leading-snug text-[hsl(var(--vc-ink))] md:text-lg">
          {t("independence.prefix")}{" "}
          <span className="text-brand">{t("independence.highlight")}</span>
        </p>
      </div>
      <ul className="mt-5 grid gap-x-6 gap-y-2.5 sm:grid-cols-2">
        {points.map((point) => (
          <li key={point} className="flex items-start gap-2 text-sm text-[hsl(var(--vc-slate))]">
            <Check className="mt-0.5 h-4 w-4 shrink-0 text-brand" strokeWidth={3} />
            <span>{point}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default IndependenceStrip;
